type Translations = {
  billingEmailPlaceholder: string;
  billingNamePlaceholder: string;
  billingAddressLine1Placeholder: string;
  billingAddressZipPlaceholder: string;
  billingAddressCityPlaceholder: string;
  billingAddressCountryPlaceholder: string;
  countrySelectorDefaultValueLabel: string;
};

const en: Translations = {
  billingEmailPlaceholder: 'Email',
  billingNamePlaceholder: 'Name',
  billingAddressLine1Placeholder: 'Street',
  billingAddressZipPlaceholder: 'Zip',
  billingAddressCityPlaceholder: 'City',
  billingAddressCountryPlaceholder: 'Country',
  countrySelectorDefaultValueLabel: 'Select country',
};

const nl: Translations = {
  billingEmailPlaceholder: 'E-mail',
  billingNamePlaceholder: 'Naam',
  billingAddressLine1Placeholder: 'Straat',
  billingAddressZipPlaceholder: 'Postcode',
  billingAddressCityPlaceholder: 'Stad',
  billingAddressCountryPlaceholder: 'Land',
  countrySelectorDefaultValueLabel: 'Selecteer land',
};

const ca: Translations = {
  billingEmailPlaceholder: 'Correu electrònic',
  billingNamePlaceholder: 'Nom',
  billingAddressLine1Placeholder: 'Carrer',
  billingAddressZipPlaceholder: 'Codi Postal',
  billingAddressCityPlaceholder: 'Ciutat',
  billingAddressCountryPlaceholder: 'País',
  countrySelectorDefaultValueLabel: 'Selecciona país',
};

const da: Translations = {
  billingEmailPlaceholder: 'E-mail',
  billingNamePlaceholder: 'Navn',
  billingAddressLine1Placeholder: 'Gade',
  billingAddressZipPlaceholder: 'Postnummer',
  billingAddressCityPlaceholder: 'By',
  billingAddressCountryPlaceholder: 'Land',
  countrySelectorDefaultValueLabel: 'Vælg land',
};

const de: Translations = {
  billingEmailPlaceholder: 'Email',
  billingNamePlaceholder: 'Name',
  billingAddressLine1Placeholder: 'Straße',
  billingAddressZipPlaceholder: 'Postleitzahl',
  billingAddressCityPlaceholder: 'Stadt',
  billingAddressCountryPlaceholder: 'Land',
  countrySelectorDefaultValueLabel: 'Land auswählen',
};

const el: Translations = {
  billingEmailPlaceholder: 'Ilektroniki̱ dief̱thynsi̱',
  billingNamePlaceholder: 'Onoma',
  billingAddressLine1Placeholder: 'Drómos',
  billingAddressZipPlaceholder: 'Tachydromikós Kódikas',
  billingAddressCityPlaceholder: 'Póli',
  billingAddressCountryPlaceholder: 'Chóra',
  countrySelectorDefaultValueLabel: 'Epiléxte chóra',
};

const es: Translations = {
  billingEmailPlaceholder: 'Correo electrónico',
  billingNamePlaceholder: 'Nombre',
  billingAddressLine1Placeholder: 'Calle',
  billingAddressZipPlaceholder: 'Código postal',
  billingAddressCityPlaceholder: 'Ciudad',
  billingAddressCountryPlaceholder: 'País',
  countrySelectorDefaultValueLabel: 'Seleccionar país',
};

const eu: Translations = {
  billingEmailPlaceholder: 'Emaila',
  billingNamePlaceholder: 'Izena',
  billingAddressLine1Placeholder: 'Kalean',
  billingAddressZipPlaceholder: 'Posta Kodea',
  billingAddressCityPlaceholder: 'Hiria',
  billingAddressCountryPlaceholder: 'Herria',
  countrySelectorDefaultValueLabel: 'Hautatu Herrialdea',
};

const fi: Translations = {
  billingEmailPlaceholder: 'Sähköposti',
  billingNamePlaceholder: 'Nimi',
  billingAddressLine1Placeholder: 'Katu',
  billingAddressZipPlaceholder: 'Postinumero',
  billingAddressCityPlaceholder: 'Kaupunki',
  billingAddressCountryPlaceholder: 'Maa',
  countrySelectorDefaultValueLabel: 'Valitse maa',
};

const fr: Translations = {
  billingEmailPlaceholder: 'Adresse électronique',
  billingNamePlaceholder: 'Prénom',
  billingAddressLine1Placeholder: 'Rue',
  billingAddressZipPlaceholder: 'Code Postal',
  billingAddressCityPlaceholder: 'Ville',
  billingAddressCountryPlaceholder: 'Pays',
  countrySelectorDefaultValueLabel: 'Choisissez le pays',
};

const it: Translations = {
  billingEmailPlaceholder: 'Indirizzo email',
  billingNamePlaceholder: 'Nome',
  billingAddressLine1Placeholder: 'Strada',
  billingAddressZipPlaceholder: 'Cerniera lampo',
  billingAddressCityPlaceholder: 'Città',
  billingAddressCountryPlaceholder: 'Nazione',
  countrySelectorDefaultValueLabel: 'Seleziona il paese',
};

const ja: Translations = {
  billingEmailPlaceholder: '電子メールアドレス',
  billingNamePlaceholder: '名',
  billingAddressLine1Placeholder: '通り',
  billingAddressZipPlaceholder: '郵便番号',
  billingAddressCityPlaceholder: 'シティ',
  billingAddressCountryPlaceholder: '国',
  countrySelectorDefaultValueLabel: '国を選択',
};

const no: Translations = {
  billingEmailPlaceholder: 'Epostadresse',
  billingNamePlaceholder: 'Navn',
  billingAddressLine1Placeholder: 'Gate',
  billingAddressZipPlaceholder: 'Post kode',
  billingAddressCityPlaceholder: 'By',
  billingAddressCountryPlaceholder: 'Land',
  countrySelectorDefaultValueLabel: 'Velg land',
};

const pl: Translations = {
  billingEmailPlaceholder: 'Adres e-mail',
  billingNamePlaceholder: 'Nazwa',
  billingAddressLine1Placeholder: 'Ulica',
  billingAddressZipPlaceholder: 'Kod pocztowy',
  billingAddressCityPlaceholder: 'Miasto',
  billingAddressCountryPlaceholder: 'Kraj',
  countrySelectorDefaultValueLabel: 'Wybierz kraj',
};

const pt: Translations = {
  billingEmailPlaceholder: 'Endereço de e-mail',
  billingNamePlaceholder: 'Nome',
  billingAddressLine1Placeholder: 'Rua',
  billingAddressZipPlaceholder: 'Código postal',
  billingAddressCityPlaceholder: 'Cidade',
  billingAddressCountryPlaceholder: 'País',
  countrySelectorDefaultValueLabel: 'Selecione o pais',
};

const sv: Translations = {
  billingEmailPlaceholder: 'E-postadress',
  billingNamePlaceholder: 'Namn',
  billingAddressLine1Placeholder: 'Gata',
  billingAddressZipPlaceholder: 'Postnummer',
  billingAddressCityPlaceholder: 'Stad',
  billingAddressCountryPlaceholder: 'Land',
  countrySelectorDefaultValueLabel: 'Välj land',
};

const zhCN: Translations = {
  billingEmailPlaceholder: '电子邮件地址',
  billingNamePlaceholder: '名称',
  billingAddressLine1Placeholder: '街',
  billingAddressZipPlaceholder: '邮政编码',
  billingAddressCityPlaceholder: '市',
  billingAddressCountryPlaceholder: '国家',
  countrySelectorDefaultValueLabel: '选择国家',
};

const zhTW: Translations = {
  billingEmailPlaceholder: '電子郵件地址',
  billingNamePlaceholder: '名稱',
  billingAddressLine1Placeholder: '街',
  billingAddressZipPlaceholder: '郵政編碼',
  billingAddressCityPlaceholder: '市',
  billingAddressCountryPlaceholder: '國家',
  countrySelectorDefaultValueLabel: '選擇國家',
};

const translations = {
  ca,
  da,
  de,
  el,
  en,
  es,
  eu,
  fi,
  fr,
  it,
  ja,
  nl,
  no,
  pl,
  pt,
  sv,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
} as const;

export type TextLocale = keyof typeof translations;

export const renderMessage = (id: keyof Translations, locale: TextLocale) => {
  if (!id) return false;

  const languageObj = translations[locale] || translations.en;
  const message = languageObj[id] || en[id];

  return message || '';
};
